module.exports = __webpack_public_path__ + "static/home-d1c26be7ac7cc6de793eeffd5427f219.jpg";